import { CloseOutlined, HolderOutlined } from "@ant-design/icons"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { Button, Card, Flex, Tag, Typography } from "antd"
import React from "react"

import type {
  DocumentAvailableBlock,
  DocumentTemplateBlock
} from "../../../types/types.ts"

interface SortableBlockItemProps {
  block: DocumentTemplateBlock
  fieldName: number
  availableBlock?: DocumentAvailableBlock
  onRemove: () => void
}

export function TemplateFormSortableBlockItem({
  block,
  availableBlock,
  onRemove
}: SortableBlockItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: block.id })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Card size={"small"}>
        <Flex align="center" gap="middle">
          <Button
            type="text"
            size="small"
            icon={<HolderOutlined />}
            style={{ cursor: "grab" }}
            {...listeners}
          />

          <Typography.Text ellipsis>
            {/*{availableBlock?.icon} */}
            {availableBlock?.label ?? block.block_type}
          </Typography.Text>

          <Flex align="center" gap="small" style={{ marginLeft: "auto" }}>
            {availableBlock?.is_data_bound && (
              <Tag color="purple" bordered={false}>
                auto-filled
              </Tag>
            )}

            {availableBlock?.removable ? (
              <Button
                type="text"
                size="small"
                icon={<CloseOutlined />}
                onClick={onRemove}
              />
            ) : (
              <span className={"w-6"} />
            )}
          </Flex>
        </Flex>
      </Card>
    </div>
  )
}
